import { useState } from "react";
import { toast } from "sonner";
import { Loader2, Star } from "lucide-react";
import { clearDefaultVoice, setDefaultVoice } from "@/lib/sunoVoicesApi";
import { safeApiError } from "@/lib/safeErrorText";

/** "Use for every new song" ⇄ "Default for new songs" (only one voice is the default). */
export default function DefaultToggle({ voice, onChanged }) {
  const [busy, setBusy] = useState(false);
  if (voice.status !== "ready") return null;
  const on = voice.is_default;
  const flip = async () => {
    setBusy(true);
    try {
      onChanged(await (on ? clearDefaultVoice(voice.id) : setDefaultVoice(voice.id)));
      toast.success(on ? "New songs start with the plain AI singer" : "Every new song starts with this voice", { description: on ? undefined : "You can still change it in the Model menu." });
    } catch (e) { toast.error("Didn't work", { description: safeApiError(e) }); }
    setBusy(false);
  };
  return (
    <button type="button" data-testid="suno-voice-default-toggle" data-default={on} onClick={flip} disabled={busy} title={on ? "Click to stop using it as the default" : undefined}
      className={`inline-flex items-center gap-1.5 rounded-full px-3 py-1.5 text-[12px] font-semibold transition-colors disabled:opacity-50 ${on ? "bg-cyan-300 text-black hover:bg-cyan-200" : "border border-white/12 bg-white/[0.05] text-white/80 hover:bg-white/[0.12]"}`}>
      {busy ? <Loader2 className="h-3.5 w-3.5 animate-spin" /> : <Star className={`h-3.5 w-3.5 ${on ? "fill-black" : ""}`} />}
      {on ? "Default for new songs" : "Use for every new song"}
    </button>
  );
}
